import { useContext, useEffect } from 'react'

import { ComposerContext } from '../ComposerContext'
import { installZustandToChannelSelectionMirror } from './installZustandToChannelSelectionMirror'
import { useModeStateEnabled } from './useModeStateEnabled'

/**
 * Mount the Zustand→Flux channel-selection mirror while
 * `composer-zustand-mode-state` is on. Off: a no-op — `ChannelSelector.tsx`'s
 * existing dual-dispatch remains the only sync path, unchanged.
 *
 * Must run inside `ComposerContext.Provider`.
 */
export function useChannelSelectionMirror(): void {
  const store = useContext(ComposerContext)
  if (!store) {
    throw new Error(
      'useChannelSelectionMirror must be used within ComposerProvider',
    )
  }
  const modeStateEnabled = useModeStateEnabled()

  useEffect(() => {
    if (!modeStateEnabled) return

    const unsubscribe = installZustandToChannelSelectionMirror(store)
    return unsubscribe
  }, [store, modeStateEnabled])
}
